module.exports = __webpack_public_path__ + "static/media/product-images-placeholder.70c3da60.png";